export const PAGE_SIZE = 10;

export enum CSV_UPLOAD_TYPES {
    USER = 'user',
    OFFER = 'offer',
    STORE = 'store'
}